/**
 * Debug Logger — Temporary diagnostic logging
 * 
 * Active until: 2026-03-06 (7 days observation period)
 * Categories: build, auth, refetch, visibility
 * 
 * Logs are prefixed and timestamped for easy filtering in console.
 * After expiry date, all calls become no-ops automatically.
 */

const DEBUG_EXPIRY = new Date('2026-12-31T23:59:59Z').getTime();

type DebugCategory = 'build' | 'auth' | 'refetch' | 'visibility';

const CATEGORY_ICONS: Record<DebugCategory, string> = {
  build: '🔧',
  auth: '🔑',
  refetch: '🔄',
  visibility: '👁️',
};

const isActive = Date.now() < DEBUG_EXPIRY;

export function debugLog(category: DebugCategory, message: string, data?: Record<string, unknown>) {
  if (!isActive) return;

  const icon = CATEGORY_ICONS[category];
  const timestamp = new Date().toISOString().slice(11, 23);
  const prefix = `[NetUno:${category}]`;

  if (data) {
    console.log(`${icon} ${prefix} ${timestamp} ${message}`, data);
  } else {
    console.log(`${icon} ${prefix} ${timestamp} ${message}`);
  }
}

export function debugWarn(category: DebugCategory, message: string, data?: Record<string, unknown>) {
  if (!isActive) return;

  const icon = CATEGORY_ICONS[category];
  const timestamp = new Date().toISOString().slice(11, 23);
  const prefix = `[NetUno:${category}]`;

  if (data) {
    console.warn(`${icon} ${prefix} ${timestamp} ${message}`, data);
  } else {
    console.warn(`${icon} ${prefix} ${timestamp} ${message}`);
  }
}

export function debugError(category: DebugCategory, message: string, data?: Record<string, unknown>) {
  if (!isActive) return;

  const icon = CATEGORY_ICONS[category];
  const timestamp = new Date().toISOString().slice(11, 23);
  const prefix = `[NetUno:${category}]`;

  if (data) {
    console.error(`${icon} ${prefix} ${timestamp} ${message}`, data);
  } else {
    console.error(`${icon} ${prefix} ${timestamp} ${message}`);
  }
}
